/** css */
import './GanttMassiveProgress.css';
import GanttMassiveProgress from './GanttMassiveProgress';

export default GanttMassiveProgress;
